// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"747":"096502ad","787":"12d85495","789":"e8592fb9","955":"9bd62ca0"}[chunkId] + ".chunk.js";
};